// 骰子引擎

export function rollDice(): [number, number] {
  const d1 = Math.floor(Math.random() * 6) + 1;
  const d2 = Math.floor(Math.random() * 6) + 1;
  return [d1, d2];
}

export function rollSingle(): number {
  return Math.floor(Math.random() * 6) + 1;
}

// 双骰取高（兔子赌徒）
export function rollDoubleHigh(): [number, number] {
  const d1 = Math.floor(Math.random() * 6) + 1;
  const d2 = Math.floor(Math.random() * 6) + 1;
  return [d1, d2];
}

// 双骰取低（兔子赌徒策略）
export function rollDoubleLow(): [number, number] {
  const d1 = Math.floor(Math.random() * 6) + 1;
  const d2 = Math.floor(Math.random() * 6) + 1;
  return [Math.min(d1, d2), 0]; // 第二个骰子为0表示不使用
}

// 自选点数（精准导航）
export function chooseSteps(chosen: number): number {
  return Math.max(1, Math.min(6, chosen));
}

// 特殊骰子（一夜暴富）
export function rollFortuneDice(): number {
  return Math.floor(Math.random() * 6) + 1; // 1-6
}
